module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("First published in 1989 by Hodder and Stoughton")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("This digital edition first published in 2014 by Canongate Books, 14 High Street, Edinburgh EH1 1TE")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © William McIlvanney 1989")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The moral right of the author has been asserted")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All characters in this publication are fictitious and any resemblance\nto real persons, living or dead, is purely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('i', [_vm._v("British Library Cataloguing in Publication Data")]), _c('br'), _vm._v("\nA catalogue record for this book is available on"), _c('br'), _vm._v("\nrequest from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 978 1 78211 194 8")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "href": "http://www.canongate.tv",
      "target": "_blank"
    }
  }, [_vm._v("www.canongate.tv")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaaea942","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_Copyright.vue
// module id = 66
// module chunks = 0